import * as React from "react";
const SvgFiRrFishCooked = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fish-cooked_svg__a)">
      <path
        fill="#062147"
        d="M10.053 12.46a.999.999 0 1 1 1.414-1.414l1.5 1.5a.999.999 0 1 1-1.414 1.414zm-6 6 1.5 1.5a.997.997 0 0 0 1.413 0 1 1 0 0 0 0-1.414l-1.5-1.5a.999.999 0 1 0-1.414 1.414m5.25-.75a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-3-3a.999.999 0 1 0-1.415 1.414zM23.741 7.627a2.49 2.49 0 0 1-2.232 1.375h-4.508a41 41 0 0 1-.157 3h.37c.832 0 1.608.345 2.13.947a2.8 2.8 0 0 1 .636 2.242 3.29 3.29 0 0 1-3.24 2.811h-1.316c-1.799 3.894-5.262 5.991-11.156 5.991-1.087 0-2.333-.409-3.085-1.162a3.98 3.98 0 0 1-1.162-3.086c.223-3.237.835-5.744 1.99-7.645v-.497c0-3.713 2.741-6.905 6.327-7.556a3.1 3.1 0 0 1 2.525.693 3.22 3.22 0 0 1 1.147 2.427 41 41 0 0 1 3-.157V2.503c0-.95.527-1.805 1.375-2.23a2.5 2.5 0 0 1 2.63.23 4.85 4.85 0 0 1 1.832 2.662 4.86 4.86 0 0 1 2.663 1.833c.571.768.66 1.775.231 2.63M4.395 9.52c1.44-1.028 3.285-1.706 5.614-2.097v-.219c0-.36-.158-.7-.436-.934a1.1 1.1 0 0 0-.902-.252c-1.933.351-3.59 1.722-4.276 3.501zm10.606-.509c-9.474.162-12.426 2.715-12.985 10.872-.04.567.172 1.126.58 1.535.41.41.973.62 1.534.581 8.156-.56 10.71-3.514 10.871-12.988m1.588 4.992a19 19 0 0 1-.44 2h.59c.63 0 1.172-.47 1.26-1.093.036-.254-.022-.484-.166-.65s-.363-.257-.619-.257zm5.315-7.81c-.505-.68-1.14-1.05-2.059-1.204a1 1 0 0 1-.822-.822c-.153-.919-.524-1.554-1.203-2.059a.5.5 0 0 0-.538-.049.48.48 0 0 0-.272.444v4.5h4.5a.48.48 0 0 0 .444-.274.5.5 0 0 0-.05-.537"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fish-cooked_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFishCooked;
